import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import { useRouter } from 'vue-router';
const router = useRouter();
export const event_obj = mitt();
export const btn_list = [
  {
    name: '详情',
    //type: 'dropdown',
    cb: (data: any) => {
      router.push({ path: '/log_app/log_app-loginfo/' + data.request_id + '/' + data.create_time });
    },
  },
];
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: btnTd[] = [];
